import {getActiveDocument} from '@packages/systems/core/helpers/SiteIframeMigrationHelper';
import {
  defineNativeIdPathQueryString,
  getNativeNodeByNativeIdPath,
} from '@packages/systems/core/utils/NativeIdUtils';

type ID = string;

/**
 * Find and return a native node inside the Data Manager by
 * its native id
 * @param  {String}     nativeId  The native id
 * @return {DOMElement}           The DOM element (if any)
 */
export const getTopFrameNativeNodeByNativeIdPath = (
  nativeIdPath?: ID[] | null
): HTMLElement | null => {
  if (nativeIdPath && nativeIdPath.length) {
    const queryString = defineNativeIdPathQueryString(nativeIdPath);

    return window.document.querySelector(queryString);
  } else {
    return null;
  }
};

/**
 * Find and return a native node inside the Data Manager by
 * its native id
 * @param  {String}     nativeId  The native id
 * @return {DOMElement}           The DOM element (if any)
 */
export const getCanvasFrameNativeNodeByNativeIdPath = (
  nativeIdPath?: ID[] | null,
  frameId?: string | null
): HTMLElement | null => {
  if (nativeIdPath && nativeIdPath.length) {
    // getNativeNodeByNativeIdPath returns null when there is no active
    // document; this accessor intentionally throws instead, so guard first.
    if (!getActiveDocument()) {
      throw new Error('Could not get document');
    }

    return getNativeNodeByNativeIdPath(nativeIdPath, frameId);
  } else {
    return null;
  }
};
